<template>
  <section data-component="c footer">
    <nav>
      FOOTER
    </nav>
  </section>
</template>

<script>
export default {
  name: 'CFooter',
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
